module.exports = new __parcel__URL__("kick_3.d59afb9a.mp3").toString();